import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css';
import mIcon from '@/assets/icons/m-icon.vue';
import {ICONS} from '@/assets/icons/icon-map';
import ru from 'vuetify/es5/locale/ru';

Vue.use(Vuetify);

const vuetifyIconValues = Object.fromEntries(
    Object.keys(ICONS).map(name => [
        name,
        {component: mIcon, props: {name}}
    ])
);

export default new Vuetify({
    lang: {
        locales: {
            ru: {
                ...ru,
                daysShort: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
                firstDayOfWeek: 1,
            }
        },
        current: 'ru'
    },
    theme: {
        themes: {
            light: {
                primary: '#8486D3',
                lightPrimary: '#C0C2FF',
                error: '#E77985'
            },
        },
    },
    icons: {
        iconfont: 'mdi',
        values: vuetifyIconValues
    },
});
